__turbopack_context__.v({
  "addItemButton": "eGNXSq_addItemButton",
  "bottomBar": "eGNXSq_bottomBar",
  "bottomBarNoInstallments": "eGNXSq_bottomBarNoInstallments",
  "container": "eGNXSq_container",
  "icon": "eGNXSq_icon",
  "immutable": "eGNXSq_immutable",
  "itemContainer": "eGNXSq_itemContainer",
  "labelContainer": "eGNXSq_labelContainer",
  "remove": "eGNXSq_remove",
});
